import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ICheckoutProps } from './types';
import axiosInstance from './utils/axiosInstance';
import { resolveBaseUrl } from 'utils/resolveBaseUrl';
import PageProvider from 'context/pageContext';
import CardProvider from 'context/cardContext';
import TransactionProvider from 'context/transactionContext';
import TransferProvider from 'context/TransferContext';
import ErrorProvider from 'context/ErrorContext';
import { TimerProvider } from 'context/TimerContext';

window.onmessage = (event) => {
  if (!event?.data?.publicKey) {
    return;
  }
  axiosInstance.interceptors.request.use((config) => {
    config.headers['Authorization'] = `${event.data.publicKey}`;
    return config;
  });

  axiosInstance.interceptors.request.use((config) => {
    config.baseURL = resolveBaseUrl(event.data.mode);
    return config;
  });

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <PageProvider>
        <CardProvider>
          <TransferProvider>
            <TransactionProvider>
              <ErrorProvider>
                <TimerProvider>
                  <App {...(event.data as ICheckoutProps)} />
                </TimerProvider>
              </ErrorProvider>
            </TransactionProvider>
          </TransferProvider>
        </CardProvider>
      </PageProvider>
    </React.StrictMode>
  );
};

reportWebVitals();
